import axios from "axios";
import { shipClientEvent, redactHeaders } from "./clientLog";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  // Hard 20s ceiling so a hung backend can never freeze the UI (previously
  // no timeout = `checkAuth` could hang forever → dark "Loading…" screen).
  timeout: 20000,
});

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  cfg.metadata = { start: Date.now() };
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const cfg = err.config || {};
    const start = cfg.metadata?.start;
    const duration = start ? Date.now() - start : null;
    const status = err.response?.status;
    const url = `${cfg.method?.toUpperCase() || "GET"} ${cfg.baseURL || ""}${cfg.url || ""}`;

    // Ship every failed request to the telemetry endpoint (but NEVER ship the
    // telemetry endpoint's own errors → would loop. shipClientEvent uses a
    // bare axios so its own failures are silently swallowed).
    if (!String(cfg.url || "").includes("/client-log")) {
      let request_body = null;
      try {
        if (cfg.data != null) {
          request_body = typeof cfg.data === "string" ? cfg.data : JSON.stringify(cfg.data);
        }
      } catch { /* ignore unserializable bodies */ }
      shipClientEvent({
        level: "error",
        source: "axios",
        message: err.message || "request failed",
        method: cfg.method?.toUpperCase() || null,
        url,
        status: status || null,
        duration_ms: duration,
        request_headers: redactHeaders(cfg.headers),
        request_body,
        response_headers: redactHeaders(err.response?.headers),
        response_body:
          err.response?.data && typeof err.response.data === "object"
            ? JSON.stringify(err.response.data).slice(0, 2000)
            : String(err.response?.data || "").slice(0, 2000),
      });
    }

    if (status === 401 && !window.location.pathname.startsWith("/login")) {
      try { localStorage.removeItem("token"); } catch {}
      // Hard-redirect so we don't leave the user stuck on a protected route
      // rendering a stale dark "Loading…" splash. Only redirect once per tab.
      if (!window.__e1Redirecting401) {
        window.__e1Redirecting401 = true;
        window.location.replace("/login");
      }
    }
    return Promise.reject(err);
  }
);

export default api;
